module.exports = __webpack_public_path__ + "first-500_paper.jpg?e80d49335d43384a7866fa477e0324b7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-500_paper.jpg
// module id = 558
// module chunks = 0